import { Button } from "@/components/ui/button";
type RoleSelectionStepProps = {
  onRoleSelect: (role: "client" | "therapist") => void;
};
const RoleSelectionStep = ({
  onRoleSelect
}: RoleSelectionStepProps) => {
  return <div className="space-y-4">
    <div className="flex flex-col items-center mb-2">
      <img src="/clou_logo.png" alt="Clou Logo" style={{ height: 48 }} />
    </div>
    <div className="text-xl font-bold text-center mb-1">I am a...</div>
    <div className="text-center text-[#5A636E] mb-2">Choose your role to continue</div>
    <Button
      onClick={() => onRoleSelect("client")}
      className="w-full mb-4 py-6 bg-[#E8F0F8] hover:bg-[#3BAFDA] active:bg-[#C8DCF0] text-[#333B44] border border-[#C8DCF0] shadow-sm transition-colors"
    >
      I am a Journaler
    </Button>
    
    <Button
      onClick={() => onRoleSelect("therapist")}
      className="w-full py-6 bg-[#E8F0F8] hover:bg-[#3BAFDA] active:bg-[#C8DCF0] text-[#333B44] border border-[#C8DCF0] shadow-sm transition-colors"
    >
      I am a Therapist
    </Button>
    
    <p className="text-sm text-[#5A636E] mt-4 text-center">Please note that therapist registration is subject to review and approval by our team to ensure compliance with the guidelines.</p>
  </div>;
};
export default RoleSelectionStep;